import { fork } from "redux-saga-test-plan/matchers";
import { watchLoadArtistBaseData } from "./sagas/loadArtistBaseData";
import { watchSaveArtistBase } from "./sagas/saveArtistBase";
import { watchSaveArtistWorkTime } from "./sagas/saveArtistWorkTime";
import { watchDeleteWorkTime } from "./sagas/deleteWorkTime";
import { watchSaveArtistAssistData } from "./sagas/saveArtistAssistData";
import { watchDeactivateArtists } from "./sagas/deactivate";
import { watchSetArtistAdmin } from "./sagas/setArtistAdmin";
import { watchSetArtistVoucherRights } from "./sagas/setArtistIssuesVouchers";
import { watchReactivateArtist } from "./sagas/reactivateArtist";
import { watchCopyArtists } from "./sagas/copyArtist";
import { watchDeleteArtists } from "./sagas/deleteArtist";
import { watchSetArtistGglSync } from "./sagas/setArtistGglSync";

const artistSaga = [
    fork(watchSaveArtistBase),
    fork(watchLoadArtistBaseData),
    fork(watchSaveArtistWorkTime),
    fork(watchDeleteWorkTime),
    fork(watchSaveArtistAssistData),
    fork(watchDeactivateArtists),
    fork(watchSetArtistAdmin),
    fork(watchSetArtistVoucherRights),
    fork(watchSetArtistGglSync),
    fork(watchReactivateArtist),
    fork(watchCopyArtists),
    fork(watchDeleteArtists),
];
export default artistSaga;
